import { isNullOrUndef } from '../../js/helpers/isNullOrUndef';
import { isNotNullOrUndef } from '../../js/helpers/isNotNullOrUndef';
const pageTitle = document.querySelector('.product__title h1');
const headTitle = document.querySelector('head title');
const metaTitles = [
    document.querySelector('head meta[property="og:title"]'),
    document.querySelector('head meta[name="twitter:title"]')
];
const metaDescriptions = [
    document.querySelector('head meta[name="description"]'),
    document.querySelector('head meta[property="og:description"]'),
    document.querySelector('head meta[name="twitter:description"]')
];
const keywords = {
    'painting-wall-art': {
        main: {
            kw1: 'Painting',
            kw2: 'Wall Art'
        },
        'framed canvas': {
            kw1: 'Framed Canvas',
            kw2: 'Print'
        },
        'framed print': {
            kw1: 'Framed Print',
            kw2: 'Art'
        },
        'poster print': {
            kw1: 'Poster Print',
            kw2: 'Art'
        },
        1: {
            kw1: 'Canvas',
            kw2: 'Print'
        },
        multi: {
            kw1: '{{n}} Piece Canvas',
            kw2: 'Wall Art'
        }
    },
    'photography-medium-wall-art': {
        main: {
            kw1: 'Photography',
            kw2: 'Wall Art'
        },
        'framed canvas': {
            kw1: 'Framed Canvas',
            kw2: 'Wall Art'
        },
        'framed print': {
            kw1: 'Framed Print',
            kw2: 'Art'
        },
        'poster print': {
            kw1: 'Poster Print',
            kw2: 'Art'
        },
        1: {
            kw1: 'Canvas',
            kw2: 'Wall Art'
        },
        multi: {
            kw1: '{{n}} Piece',
            kw2: 'Print'
        }
    },
    'drawing-wall-art': {
        main: {
            kw1: 'Drawing',
            kw2: 'Wall Art'
        },
        'framed canvas': {
            kw1: 'Framed Drawing',
            kw2: 'Canvas'
        },
        'framed print': {
            kw1: 'Framed Art',
            kw2: 'Print'
        },
        'poster print': {
            kw1: 'Poster Art',
            kw2: 'Print'
        },
        1: {
            kw1: 'Sketch',
            kw2: 'Drawing'
        },
        multi: {
            kw1: '{{n}} Piece Drawing',
            kw2: 'Art'
        }
    },
    'graffiti-wall-art': {
        main: {
            kw1: 'Graffiti',
            kw2: 'Wall Art'
        },
        'framed canvas': {
            kw1: 'Framed Canvas',
            kw2: 'Graffiti'
        },
        'framed print': {
            kw1: 'Framed Print',
            kw2: 'Art'
        },
        'poster print': {
            kw1: 'Poster Print',
            kw2: 'Art'
        },
        1: {
            kw1: 'Canvas',
            kw2: 'Picture'
        },
        multi: {
            kw1: '{{n}} Piece Print',
            kw2: 'Graffiti'
        }
    },
    'digital-art-wall-art': {
        main: {
            kw1: 'Digital Art',
            kw2: 'Wall Art'
        },
        'framed canvas': {
            kw1: 'Framed Digital Art',
            kw2: 'Canvas'
        },
        'framed print': {
            kw1: 'Framed Digital Print',
            kw2: 'Art'
        },
        'poster print': {
            kw1: 'Poster Digital Print',
            kw2: 'Art'
        },
        1: {
            kw1: 'Illustration',
            kw2: 'Print'
        },
        multi: {
            kw1: '{{n}} Piece Digital Art',
            kw2: 'Print'
        }
    },
    'watercolor-wall-art': {
        main: {
            kw1: 'Watercolor',
            kw2: 'Wall Art'
        },
        'framed canvas': {
            kw1: 'Framed Watercolor',
            kw2: 'Canvas'
        },
        'framed print': {
            kw1: 'Framed Watercolor Canvas',
            kw2: 'Art'
        },
        'poster print': {
            kw1: 'Poster Watercolor Canvas',
            kw2: 'Art'
        },
        1: {
            kw1: 'Watercolor Art',
            kw2: 'Print'
        },
        multi: {
            kw1: '{{n}} Piece Artwork',
            kw2: 'Watercolor'
        }
    }
};
export const pageProductSEO = (variant) => {
    const mediumType = window.productPage?.mediumType;
    if (isNullOrUndef(window.productPage) || isNullOrUndef(mediumType))
        return;
    const layout = variant.option1.toLowerCase();
    let kw1;
    let kw2;
    if (layout.includes('piece')) {
        const pieces = layout.split(' ')[0];
        const layoutKey = pieces !== '1' ? 'multi' : pieces;
        const kws = keywords[mediumType][layoutKey];
        kw1 = kws.kw1.replace('{{n}}', pieces);
        kw2 = kws.kw2;
    }
    else {
        const kws = keywords[mediumType][layout];
        kw1 = kws.kw1;
        kw2 = kws.kw2;
    }
    if (isNotNullOrUndef(pageTitle)) {
        pageTitle.textContent = `${window.productPage.title} ${kw2}`;
    }
    const metaTitleContent = `${window.productPage.title} ${kw2} | ${kw1}${isNotNullOrUndef(window.productPage.artistName) ? ' | by ' + window.productPage.artistName : ''}`;
    if (isNotNullOrUndef(headTitle)) {
        headTitle.textContent = metaTitleContent;
    }
    metaTitles.forEach(elem => {
        elem?.setAttribute('content', metaTitleContent);
    });
    const discount = Math.round(100 - (variant.price / variant.compare_at_price * 100));
    const descriptionContent = `Shop for ${window.productPage.title} ${kw2}${isNotNullOrUndef(window.productPage.artistName) ? ' by ' + window.productPage.artistName : ''}. This ready to hang ${window.productPage.title} ${kw1} artwork is currently on a ${discount}% discount and includes free shipping - Learn More`;
    metaDescriptions.forEach(elem => {
        elem?.setAttribute('content', descriptionContent);
    });
};
